import notificationSoundFile from "../audio/notification.wav"; 

class NotificationSound {
  constructor(src, { volume = 1.0, preload = true } = {}) {
    this.src = src;
    this.audio = new Audio(src);
    this.audio.volume = volume;
    if (preload) {
      this.audio.preload = "auto";
      this.audio.load();
    }
  }

  play() {
    try {
      this.audio.currentTime = 0;
      const playPromise = this.audio.play();
      if (playPromise !== undefined) {
        playPromise.catch((err) => {
          console.warn("Notification sound blocked (needs user interaction first):", err);
        });
      }
    } catch (e) {
      console.warn("Could not play notification sound:", e);
    }
  }

  setVolume(volume) {
    this.audio.volume = volume;
  }
}

const notificationSound = new NotificationSound(notificationSoundFile, { volume: 1.0 });

export async function requestNotificationPermission() {
  if (!("Notification" in window)) {
    console.log("Notifications are not supported");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission === "denied") {
    return false;
  }

  const permission = await Notification.requestPermission();

  return permission === "granted";
}

export function showSystemNotification(title, message) {
  if (Notification.permission !== "granted") {
    return;
  }

  notificationSound.play();

  new Notification(title, {
    body: message,
    silent: false,
  });
}